import { makeAutoObservable } from "mobx"

class ProfileStore {
  isMenuOpen = true

  constructor() {
    makeAutoObservable(this)
  }
  setisMenuOpen(profileState: boolean) {
    this.isMenuOpen = profileState
  }
}

const profileState = new ProfileStore()

export default profileState